import keyCodes from '../../../../../../editJournal/constants/keyCodes';

export default (params) => {
  const { event, editor, focusBlock } = params;

  if (event.which === keyCodes.A && (event.ctrlKey || event.metaKey)) {
    event.preventDefault();

    let { type: blockType, key: blockKey } = focusBlock;
    const {
      value: { document },
    } = editor;
    let blockNode = focusBlock;
    while (
      blockType === 'paragraph' ||
      blockType === 'list_item' ||
      blockType === 'unordered_list'
    ) {
      blockNode = document.getParent(blockKey);
      ({ type: blockType, key: blockKey } = blockNode);
    }

    editor.moveToRangeOfNode(blockNode);
    return true;
  }

  return false;
};
